<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div fxFlex>
    <form [formGroup]="form"> 
      <mat-form-field class="width-100">
        <input 
          matInput
          #chain_typeInput
          formControlName="chain_type" 
          [matAutocomplete]="chain_typeAC" 
          [placeholder]="'LABEL_CHAIN_TYPE' | translate"
          (focus)="!chain_typeAC.isOpen && getInitialValues('chain_type')" 
          (blur)="checkAutocompleteObject(form, 'chain_type')"
          [required]="isRequired"
          >

        <mat-icon 
          id="id_select_chain_type_delete_btn"
          matSuffix 
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          (click)="chain_typeInput.blur(); clearForm($event)"
          *ngIf="chain_typeInput.value && !disabled"
          >
        </mat-icon>

        <mat-icon 
          matSuffix 
          class="clear-input"
          svgIcon="menu-down"
          *ngIf="!chain_typeInput.value"
          >
        </mat-icon>

        <mat-autocomplete 
          id="id_select_chain_type_dropdown"
          [displayWith]="displayFn" 
          #chain_typeAC="matAutocomplete" 
          (closed)="autoCmpltClosed(); chain_typeInput.blur()"
          (opened)="autocompleteScroll('chain_type','chain_typeACRef','chain_typeACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.chain_type && listData?.length == 0"
            >
            {{ 'LABEL_NO_DATA' | translate }}
          </mat-option>

          <mat-option
            [id]="'id_select_chain_type_data_' + (i+1)"
            [value]="data" 
            matTooltipPosition="right"
            *ngFor="let data of listData; let i = index" 
            [matTooltip]="data.code + ' - ' + data.description"
            >
            {{ data.code }} - {{ data.description }}
          </mat-option>

          <mat-option *ngIf="loading.chain_type" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="form.get('chain_type').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="form.get('chain_type').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: 'LABEL_CHAIN_TYPE' | translate} }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>